module.exports = __webpack_public_path__ + "img/incident.0e4c140f.png";